import React from "react";

export default function PowerFilterTools({
  boardSelection,
  userIsPro,
  environment,
}) {
  return (
    <div>Waiting on certain SDK capabilities to arrive to offer this tool.</div>
  );
}
